import { render, staticRenderFns } from "./ResidentialForRent.vue?vue&type=template&id=731ed3c4&scoped=true&"
import script from "./ResidentialForRent.vue?vue&type=script&lang=ts&"
export * from "./ResidentialForRent.vue?vue&type=script&lang=ts&"
import style0 from "./ResidentialForRent.vue?vue&type=style&index=0&id=731ed3c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "731ed3c4",
  null
  
)

export default component.exports